module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov10-514ab86d5962f0d4dbdaeba1cee49075.jpg";